import * as React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();
const MinusSvgComponent = ({ fill = '#44338A' }: { fill?: string }) => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1H15" stroke={fill} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="22" height="4" viewBox="0 0 22 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.66675 2H20.3334"
                    stroke={fill}
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width={12} height={2} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.333 1h9.333" stroke={fill} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default MinusSvgComponent;
